module.exports = __webpack_public_path__ + "static/img/アセット 28@2x.e713aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/アセット 28@2x.png
// module id = 7i1e
// module chunks = 1